// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { useRef, useEffect, useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';

export function nextFrame(callback: () => void): void {
  requestAnimationFrame(() => {
    requestAnimationFrame(callback)
  })
}

export function useParamsId(): number {
  const params = useParams<{ id: string }>();
  const id = parseInt(params.id, 10);
  return id;
}

export function useQuery(): URLSearchParams & { [props: string]: any } {
  const location = useLocation();
  return useMemo(() => {
    return new URLSearchParams(location.search);
  }, [location.search])
}

export function useUpdateEffect(callback: React.EffectCallback, deps: React.DependencyList): void {
  const isFirstTime = useRef(true);
  useEffect(() => {
    if (isFirstTime.current) {
      isFirstTime.current = false;
      return;
    }
    return callback();
  }, deps);
}

export function getQueryParams(hook: URLSearchParams) {
  return Array.from(hook.keys()).reduce(
    (pre: { [prop: string]: any }, key, index) => {
      pre[key] = Array.from(hook.values())[index];
      return pre;
    },
    {}
  );
}

export function useInterval(callback: () => void, ms: number): void {
  useEffect(() => {
    const interval = setInterval(callback, ms);

    return () => {
      clearInterval(interval);
    }
  }, []);
}

export function makeId(length: number) {
  let result = '';
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

/**
 * @param {number} number -
 * @return {string} - returns
 */
export function prependZero(number: number):string {
  if (number <= 9) return '0' + number;
  else return `${number}`;
}

/**
 * @typedef {Object} DurationType - object with options
 * @property {string} seconds - seconds value
 * @property {string} minutes - minutes value
 * @property {string} hours - hours value
 * @property {string} all - hours:minutes:seconds value
 * @property {string} auto - hours:minutes value
 */
type DurationType = {
  seconds: number;
  minutes: number;
  hours: number;
  all: string;
  auto: string;
}

/**
 * @param {number} duration - # seconds **bold** *italic*
 * @returns {DurationType} - object with options
 */
export const parseDuration = (duration: number): DurationType => {
  const seconds = Math.floor(duration % 60),
    minutes = Math.floor((duration / 60) % 60),
    hours = Math.floor(duration / 3600);

  return {
    seconds,
    minutes,
    hours,
    all: prependZero(hours) + ':' + prependZero(minutes) + ':' + prependZero(seconds),
    auto: hours ? `${hours}:${prependZero(minutes)}:${prependZero(seconds)}` : `${minutes}:${prependZero(seconds)}`,
  };
};

export function similarWordPoints(first: string, second: string):number {
  first = first.replace(/\s+/g, '')
  second = second.replace(/\s+/g, '')
  if (first === second) return 1;
  if (first.length < 2 || second.length < 2) return 0;
  const firstBigrams = new Map();
  for (let i = 0; i < first.length - 1; i++) {
    const bigram = first.substring(i, i + 2);
    const count = firstBigrams.has(bigram) ? firstBigrams.get(bigram) + 1 : 1;
    firstBigrams.set(bigram, count);
  }
  let intersectionSize = 0;
  for (let i = 0; i < second.length - 1; i++) {
    const bigram = second.substring(i, i + 2);
    const count = firstBigrams.has(bigram) ? firstBigrams.get(bigram) : 0;
    if (count > 0) {
      firstBigrams.set(bigram, count - 1);
      intersectionSize++;
    }
  }
  return (2.0 * intersectionSize) / (first.length + second.length - 2);
}
